import { Component, OnInit, input } from "@angular/core";
import { FeatherModule } from "angular-feather";

@Component({
    selector: "app-feather-icons",
    templateUrl: "./feather-icons.component.html",
    styleUrls: ["./feather-icons.component.sass"],
    imports: [FeatherModule]
})
export class FeatherIconsComponent implements OnInit {
  public readonly icon = input<string>('');
  public readonly class = input<string>('');
  constructor() {}

  ngOnInit(): void {}
}
